import React, { useEffect, useState, Fragment } from 'react';
import Spinner from './Spinner';
import CourseDates from './CourseDates';
import { findElementinSubElementsByName, createCourseFromCourseElement, createDatesFromCourseElement,
  createVenuesFromCourseElement, createTrainersFromCourseElement } from '../utils';

const CourseDetail = props => {
  const [course, setCourse] = useState(null)
  const [dates, setDates] = useState([])
  const [venues, setVenues] = useState([])
  const [trainers, setTrainers] = useState([])

  useEffect(() => {
    setCourse(null)
    const API_URL = "https://cosy.ox.ac.uk/accessplan/services/WebIntegration.asmx/GetCoursesPackage"
    try {
      let newCourse = {};
      let newDates = [];
      let newVenues = [];
      let newTrainers = [];

      const convert = require('xml-js');
      let dataAsJson = {};
      fetch(API_URL + "?companyID=" + props.companyId + "&categoryIDs=&courseIds=" + props.courseId + "&venueIDs=").then(response => response.text()).then(str => {
        dataAsJson = JSON.parse(convert.xml2json(str));
      }).then(() => {
        if (dataAsJson.elements[0].elements !== undefined) {
          //Create arrays of each of the things assos
          newCourse = dataAsJson.elements[0].elements[0].elements !== undefined ? createCourseFromCourseElement(dataAsJson.elements[0].elements[0].elements[0]) : { coursename: "No course detail available" };
          newDates = createDatesFromCourseElement(findElementinSubElementsByName(dataAsJson.elements[0].elements, "Dates"));
          newVenues = createVenuesFromCourseElement(findElementinSubElementsByName(dataAsJson.elements[0].elements, "Venues"));
          newTrainers = createTrainersFromCourseElement(findElementinSubElementsByName(dataAsJson.elements[0].elements, "Trainers"));
          setCourse(newCourse)
          setDates(newDates)
          setVenues(newVenues)
          setTrainers(newTrainers)
        }
      });
    } catch (error) {
      setCourse({coursename: "Course not found."})
      console.log(error);
    }
  }, [props.companyId, props.courseId])

  if (!course) {
    return <Spinner />
  } else {
    const renderRAWHTML = (rawHTML) => React.createElement("div", { dangerouslySetInnerHTML: { __html: rawHTML } });
    return (<Fragment>
      <div className="container col-md-12 coursedetail">

        <h2>{course.coursename}</h2>
        <div className="row">
          <div className="col-md-12">
            {course.text1 ? <div><h3>Description</h3>{renderRAWHTML(course.text1)}</div> : ""}
            {course.text2 ? <div><h3>Objectives</h3>{renderRAWHTML(course.text2)}</div> : ""}
            {course.text3 ? <div><h3>Pre-Requisites and Related Activities</h3>{renderRAWHTML(course.text3)}</div> : ""}
          </div>
          {course.coursetype !== "Self-serve" ? <CourseDates dates={dates} venues={venues} trainers={trainers} /> : ""}
          <div className="col-md-12">
            <br />
            <a className="btn btn-info" href="#/">&lt;&lt; Back to course list</a>
          </div>
        </div>
      </div>
    </Fragment>)
  }
}

export default CourseDetail;
